import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as L from 'leaflet';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-material-issues',
  templateUrl: './material-issues.component.html',
  styleUrls: ['./material-issues.component.css']
})
export class MaterialIssuesComponent implements OnInit {

  private map!: L.Map;
  data: any;
  cid:any
  quantityArr:any = []
  form: any | FormGroup
  modelSubtitle = false
  name = ""
  version = ""
  isActive = false
  i: any;
  deleteId: any = "";
  products: any = [];
  vendor: any = [];
  branch: any = [];
  materials: any = [];
  InfoObj:any = []
  make:any = ''
  modal:any = ''
  slNo:any = ''
  expiryDate:any = ''
  userid:any =''
  viewProd:any = []
  viewData:any = []
  viewstatus:any = [];
  uomData: any = [];
  viewinfo: any = [];


  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;

  productList:any = []
  isLoading: any = false

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

 constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllIssues(this.pageNumber,this.recordsPerPage)
    this.getAllUomMaster()
    this.form = this.fb.group({
      branchId :[''],
      branchName:['',[Validators.required]],
      vendorName:[''],
      productName:[''],
      quantity:[''],
      issueNo:['',[Validators.required]],
      issueDate:['',[Validators.required]],
      productList:this.fb.array([]),
      infoObj:this.fb.array([]),
    })  

    this.generic_service.getAllProducts().subscribe(
      (res:any)=>{
        this.products = res.response
      }
    )

    // this.generic_service.getVendor().subscribe(
    //   (res:any)=>{
    //     this.vendor = res.response
    //   }
    // )

    this.generic_service.getBranch().subscribe(
      (res:any)=>{
        console.log(res)
        this.branch = res.response
      }
    )
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.getAllIssues(this.pageNumber,this.recordsPerPage)
  }

  
  get productListArr(){
    return this.form.get('productList') as FormArray;
  }

  productListObject(){
    return this.fb.group({
      "productName": [''],
      "infoObj": this.fb.array([this.addInfoObject()]),
    })
   }

   addproductListObject(){
      this.productListArr.push(this.productListObject())
   }
  
  get infoArr(){
    return this.form.get('infoObj') as FormArray;
  }

  InfoObject(){
    return this.fb.group({
      "make": [''],
      "modal": [''],
      "slNo": [''],
      "expiryDate": [0],
    })
  }

  addInfoObject(){
    this.infoArr.push(this.InfoObject())
  }

  removeInfoObject(index: number){
    this.infoArr.removeAt(index)
  }

  resetInfoObject(){
    this.make = ''
    this.modal = ''
    this.slNo = ''
    this.expiryDate = ''
  }

  addIssue(){ 
    console.log(this.prod)

    let isValid:any = true;
    for(let list of this.prod){
      if(list.productName == "" || list.uomName == ""){
        isValid = false
      }
    }
  
    if(!this.form.valid || !isValid){
      this.toastr.error('All fields are mandatory')
      return
    }

    for(let i = 0; i < this.prod.length; i++) {
      if(this.prod[i].quantity == 0){
        for(let j = 0; j < this.prod[i].infoObj.length; j++) {
          this.prod[i].infoObj[j].expiryDate = new Date(this.prod[i].infoObj[j].expiryDate).getTime()
        }
      }else{
        this.prod[i].infoObj = []
      }

      delete this.prod[i].uomList
      delete this.prod[i].productList
    }

    for(let i=0; i<this.branch.length;i++){
      if(this.branch[i].name == this.form.get('branchName').value){
        this.form.patchValue({
          branchId: this.branch[i].branchMasterId
        })
      }
    }


    let body1 ={
      "version": 1,
      "isActive": true,
      "description": "",
      "branchId": Number(this.form.get('branchId').value),
      "branchName": String(this.form.get('branchName').value),
      "vendorName": "",
      "issueNo": String(this.form.get('issueNo').value),
      "issueDate": new Date(this.form.get('issueDate').value).getTime(),
      "status": [
        {
          "userId": Number(sessionStorage.getItem("userId")),
          "issueStatus": "REQUESTED",
          "updatedDate": new Date().getTime()
        }
      ],
      "latestStatus": "REQUESTED",
      "latestStatusUserId": 0,
      "tranType": "INVOICE",
      "productList": this.prod,
      "cid": Number(this.cid)
    }

    console.log(body1)
    this.generic_service.addIssue(body1).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllIssues(this.pageNumber,this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
        this.InfoObj = []

      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);

      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllIssues(pageNumber:any,recordsPerPage:any){
    this.isLoading = true

    this.generic_service.getAllIssues(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        this.materials = response.response.materialIssueList;
        this.totalRecords = response.response.totalRecords;
        console.log(response)
        this.isLoading = false

      }
    )
  }

  getAllProduct(){
    this.generic_service.getAllProducts().subscribe(
      (res:any)=>{
        this.products = res.response
      }
    )
  }

  getAllVendor(){
    // this.generic_service.getVendor().subscribe(
    //   (res:any)=>{
    //     this.vendor = res.response
    //   }
    // )
  }

  getAllBranch(){
    this.generic_service.getBranch().subscribe(
      (res:any)=>{
        this.branch = res.response
      }
    )
  }

  getAllUomMaster(){
    this.generic_service.getAllUomMaster().subscribe(
      (res:any)=> {
        console.log(res)
        this.uomData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  productNameSelect(index:any){
    for(let i=0;i<this.products.length;i++){
      if(this.products[i].name == this.prod[index].productName){
        console.log(this.products[i])
        this.prod[index].uomList = this.products[i].supportedUOM
      }
    }
  
    console.log(this.prod)
  }
  
  uomChange(index:any){
    for(var i=0;this.uomData.length>i;i++){
      if(this.uomData[i].uomName == this.prod[index].uomName){
        this.prod[index].uomId = this.uomData[i].uomMasterId
      }
    }
  }

  open() {
    this.modelSubtitle = true;
  }

  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.version = ""
    this.isActive = false
  }

  prod: any= []

  addP(){
    this.prod.push(
      {
        "productName":  "",
        "infoObj": [
          {
            "make": "",
            "modal": "",
            "slNo": null,
            "expiryDate": 0,
          }
        ],
        "quantity": 1,
        "uomId": 0,
        "uomName": "",
        "uomList": [],
        "productList": []
      }
    )
  }

  addi(i: any){
    this.prod[i].infoObj.push(
      {
        "make": "",
        "modal": "",
        "slNo": null,
        "expiryDate": 0,
      }
    )
    this.prod[i].quantity = this.prod[i].infoObj.length
    console.log("infoobj of prodct["+i+"]")
    console.log(this.prod)

  }

  showp(){
    console.log(this.prod)
  }

  removeProd(i:any){
    console.log(i)
    this.prod.splice(i,1)
    console.log(this.prod)
  }

  removeinfoObj(i:any,j:any){
    console.log(i)
    console.log(j)
    this.prod[i].infoObj.splice(j,1)
    this.prod[i].quantity = this.prod[i].infoObj.length

    console.log(this.prod)
  }
  
  clear() {
    this.prod = []
    this.form.reset()
    console.log(this.prod)
  }
  getMaterialById(id:any){
    this.generic_service.getMaterialIssueById(id).subscribe(
      (response:any)=>{
        console.log(response)
        console.log(response.response)
        this.viewData = []
        this.viewData.push(response.response);
        console.log(this.viewData)
        this.viewProd = []
        this.viewProd = response.response.productList
        console.log(this.viewProd)
        this.viewstatus = []
        this.viewstatus = response.response.status
        console.log(this.viewstatus)
        this.viewinfo = []
        this.viewinfo.push(response.response.productList[0].infoObj[0])
        console.log(this.viewinfo)
        if(response.response.productList[0].infoObj != 0){
          if(response.response.productList[0].infoObj[0].lat != 0 && response.response.productList[0].infoObj[0].lat != null && response.response.productList[0].infoObj[0].lat != ''){
            setTimeout(() => this.initMap(this.viewinfo[0].lat,this.viewinfo[0].lon),1000);
          }
        }
      },
      (error)=>{
        console.log(error)
      }
    )
  }

  initMap(lat:any,lon:any): void {
    let centroid1: L.LatLngExpression[]= [];
    
     
        let obj:L.LatLngExpression = [Number(lat), Number(lon)]
        centroid1.push(obj)

        this.map = L.map('map', {
          center: centroid1[0],
          zoom: 12
        });
    
        const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 18,
          minZoom: 2,
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        });
    
        // L.Icon.Default.imagePath='https://www.iconpacks.net/icons/2/free-location-icon-2955-thumb.png';
    
        // create 5 random jitteries and add them to map
        for(let i = 0; i < centroid1.length; i++){
         let loc = L.marker(centroid1[i] as L.LatLngExpression,{icon: this.defaultIcon}).bindPopup('a marker location').openPopup()
         loc.addTo(this.map)
        }
    
        
        tiles.addTo(this.map);
     
    
    console.log(this.map);
  }

  defaultIcon = L.icon({
    iconUrl: 'assets/img/loc.png', // your path may vary ...
    iconSize: [30, 30],
    iconAnchor: [2, 2],
    popupAnchor: [0, -2]
  });


  getProductVersion(product:any,index:any){
    for(var i=0; i<this.products.length;i++){
      if(this.products[i].name == product){
        if(this.products[i].version != 1){
          this.prod[index].quantity = 0
        }
        return this.products[i].version
      }
    }
  }

  selectProductName(index:any,productName:any,supportedUOM:any){
    this.prod[index].productName = productName
    this.prod[index].uomList = supportedUOM
    this.productList = []
    this.prod[index].productList = []
  }

  getAllByWildSearchWithoutPagination(index:any){
    this.prod[index].uomList = []
    if(this.prod[index].productName == ""){
      return
    }

    this.generic_service.getAllByWildSearchWithoutPagination(this.prod[index].productName).subscribe(
      (res:any)=>{
        console.log(res)
        this.productList = res.response;
        this.prod[index].productList = res.response
      },
      (err:any)=>{
        this.productList = []
        this.prod[index].productList = []
      }
    )
  }



  searchKey: any = ""

  getMaterialIssueByWildSearch(pageNumber: any,recordsPerPage: any){
    console.log(this.searchKey)
    if(this.searchKey != ""){
      this.isLoading = true

      this.generic_service.getMaterialIssueByWildSearch(this.searchKey,pageNumber,recordsPerPage).subscribe(
        (response:any)=>{
          console.log(response);
          this.materials = response.response.materialIssueList;
          this.totalRecords = response.response.totalRecords;
          this.isLoading = false

        },
        (err:any)=>{
          console.log(err)
        }
      )
    }else{
      this.getAllIssues(this.pageNumber,this.recordsPerPage)
    }
  }

  refreshSearch(){
    this.searchKey = ""
    this.getAllIssues(this.pageNumber,this.recordsPerPage)
  }

  refreshAll(){
    this.pageNumber = 0
    this.searchKey = ""
    this.getAllIssues(this.pageNumber,this.recordsPerPage)
  }
}